const getHoverTokens = (mainColors) => ({
    hover: {
        primary: `${mainColors.bulma}12`,
        secondary: `${mainColors.piccolo}12`,
    },
});
export default getHoverTokens;
